module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip path icons-05-71a17252a2dd37203ffe708a37270a1e.png";